/**
 * Idle lock for PIN member sessions (docs/design/pin-member-auth.md, decision D1 = b, Jens
 * 2026-10-09): a PIN session is never interrupted while in use, but after 60 minutes without any
 * activity the device goes back to the "who are you?" screen.
 */

export const MEMBER_IDLE_LIMIT_MS = 60 * 60 * 1000;
const LAST_ACTIVE_KEY = 'ftm_member_last_active';

/** No recorded activity counts as "just started", never as expired. */
export function isMemberIdleExpired(
  lastActiveMs: number | null | undefined,
  nowMs: number,
  limitMs: number = MEMBER_IDLE_LIMIT_MS,
): boolean {
  if (lastActiveMs == null || !Number.isFinite(lastActiveMs)) return false;
  return nowMs - lastActiveMs >= limitMs;
}

export function readMemberLastActive(): number | null {
  try {
    const raw = window.localStorage.getItem(LAST_ACTIVE_KEY);
    const n = raw ? Number(raw) : NaN;
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function markMemberActive(nowMs: number = Date.now()): void {
  try {
    window.localStorage.setItem(LAST_ACTIVE_KEY, String(nowMs));
  } catch {
    /* ignore */
  }
}

export function clearMemberLastActive(): void {
  try {
    window.localStorage.removeItem(LAST_ACTIVE_KEY);
  } catch {
    /* ignore */
  }
}
